import 'virtual:windi-base.css'
import 'virtual:windi-components.css'
import '/@/design/index.less'
import 'virtual:windi-utilities.css'

// Register icon sprite
import 'virtual:svg-icons-register'
import { createApp } from 'vue'
import App from './App.vue'
import { initAppConfigStore } from '/@/logics/initAppConfig'
import { setupErrorHandle } from '/@/logics/error-handle'
import { router, setupRouter } from '/@/router'
import { setupRouterGuard } from '/@/router/guard'
import { setupStore } from '/@/store'
import { setupGlobDirectives } from '/@/directives'
import { setupI18n } from '/@/locales/setupI18n'
import { setupAppConfig } from '/@/config/app'
import { registerGlobComp } from '/@/components/registerGlobComp'
import { isDevMode, isProdMode } from './utils/env'

// import * as Sentry from '@sentry/vue'

// fix: Added non-passive event listener to a scroll-blocking 'wheel' event
// import 'default-passive-events'

if (isDevMode()) {
    import('ant-design-vue/es/style')
}

async function bootstrap() {
    const app = createApp(App)
    // Sentry
    if (isProdMode()) {
        // Sentry.init({
        //     app,
        //     dsn: 'https://134265a4440e03b1eb5aa7b7602d32ad@o4504881827610624.ingest.us.sentry.io/4511341913964544',
        //     // Setting this option to true will send default PII data to Sentry.
        //     // For example, automatic IP address collection on events
        //     sendDefaultPii: true,
        //     integrations: [
        //         Sentry.browserTracingIntegration(),
        //         Sentry.replayIntegration(),
        //         // 新增：捕获控制台错误
        //         Sentry.captureConsoleIntegration({
        //             // 可配置要捕获的 console 级别
        //             levels: ['error', 'warn', 'info'], // 通常只需 'error'
        //         }),
        //     ],
        // })
        // Sentry.init({
        //     app,
        //     dsn: import.meta.env.VITE_SENTRY_DSN,
        //     integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
        //     // Performance Monitoring
        //     tracesSampleRate: 1.0,
        //     // Session Replay
        //     replaysSessionSampleRate: 0.1,
        //     replaysOnErrorSampleRate: 1.0,
        // })
    }

    // 注册 App 配置
    setupAppConfig(app)

    // Configure store
    // 配置 store
    setupStore(app)

    // Initialize internal system configuration
    // 初始化内部系统配置
    initAppConfigStore()

    // Register global components
    // 注册全局组件
    registerGlobComp(app)

    // Multilingual configuration
    // 多语言配置
    // Asynchronous case: language files may be obtained from the server side
    // 异步案例：语言文件可能从服务器端获取
    await setupI18n(app)

    // Configure routing
    // 配置路由
    setupRouter(app)

    // router-guard
    // 路由守卫
    setupRouterGuard(router)

    // Register global directive
    // 注册全局指令
    setupGlobDirectives(app)

    // Configure global error handling
    // 配置全局错误处理
    setupErrorHandle(app)

    // https://next.router.vuejs.org/api/#isready
    // await router.isReady();

    app.mount('#app')
}

bootstrap()
